import { Component, Input, OnInit } from '@angular/core';
import { RouteMapService } from '../../services/route-map.service';
import { SharedService } from '../../services/shared.service';
import { ITag } from '../../shared.definitions';

@Component({
  selector: 'app-card-w-desc',
  templateUrl: './card-w-desc.component.html',
  styleUrls: ['./card-w-desc.component.scss'],
})
export class CardWDescComponent implements OnInit {
  @Input() data: any;
  @Input() isFullWidth = false;
  @Input() isSlider = false;
  isLoggedIn = false;
  isAlreadyFav = false;
  tag: ITag;

  constructor(private readonly sharedService: SharedService, private readonly routeMap: RouteMapService) {}

  ngOnInit(): void {
    this.tag = this.sharedService.getTagColorAndValue(this.data);
    const sc = this.data && this.data.subComponents && this.data.subComponents[0];
    if (sc) {
      this.data = {
        ...this.data,
        customUrl: sc.customUrl,
        routerLink: this.routeMap.getRoute(sc),
        newTab: sc.newTab,
      };
    }
  }

  favButtonAction(): void {
    if (this.isLoggedIn) {
      if (this.isAlreadyFav) {
        this.setActiveDeleteElementPopup(true);
      }
    } else {
      this.setActiveLoginPopup(true);
    }
  }

  setActiveLoginPopup(active: boolean): void {
    this.sharedService.setActiveLoginPopup(active);
  }

  setActiveDeleteElementPopup(active: boolean): void {
    this.sharedService.setActiveDeleteElementPopup(active);
  }
}
